import confirmDialog from "./confirmDialog"
import Gyre from "./Gyre"

export default class SDWebservice {
    constructor() {
    }

    strip(str, remove) {
        while (str.length > 0 && remove.indexOf(str.charAt(0)) != -1) {
            str = str.substr(1)
        }
        while (str.length > 0 && remove.indexOf(str.charAt(str.length - 1)) != -1) {
            str = str.substr(0, str.length - 1)
        }
        return str
    }


    createSDGrpc(){
                return new Gyre();

    }





    async getServerFeatures(SDConfig) {
        let samplers=[]
        let width=parseInt(SDConfig.width)
        let height=parseInt(SDConfig.height)
        try {
                let gs=this.createSDGrpc()
                let features=await gs.getServerFeatures(SDConfig)
                samplers=[{name:"LMS"},{name:'Euler a'},{name:'Euler'},{name:'Heun'},{name:'DPM2'},{name:'DPM2 a'},{name:'DDIM'},{name:'PLMS'},{name:'DPMSolver++ 1 Order'},{name:'DPMSolver++ 2 Order'}
                ,{name:'DPMSolver++ 3 Order'},{name:'DPMSolver++ 2S a'},{name:'DPMSolver++ SDE'},{name:'DPMSolver++ 2M'},{name:'DPMSolver++ 2M (Fast)'}]
                let defaultProps={tiling:true, strength:true, steps:true,seed:true,samplers:samplers,hr:true,clip:true,image_number_max:9}
                if (features && features.artifacts && features.artifacts.includes("ARTIFACT_DEPTH")) defaultProps.depth=true
                if (features && features.models) defaultProps.models=features.models
                if (features && features.upscalers) defaultProps.upscalers=features.upscalers.engine
                if (features && features.model) defaultProps.model=features.model
                if (width<=512 && height <=512) defaultProps.hr=false
                defaultProps.removeBackground=true
                defaultProps.features=features.features
                return defaultProps

        } catch(error) {
            await new confirmDialog().alert("Server error",error.toString())
        }               
    }


    async getServerData(p,reqData, SDConfig) {
        let endpoint = SDConfig.url
        endpoint = this.strip(endpoint, "/")
        if (p.mode==="txt2img")       endpoint += "/sdapi/v1/txt2img"
        else  endpoint += "/sdapi/v1/img2img"
        try {
            let res= await fetch(endpoint, {
                headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"              
                }, 
                method: 'post',
                body: reqData
            })
            let result=await res.json()

            if ( !result["images"]) {
                await new confirmDialog().alert("Error",JSON.stringify(result))
                return
            }
            if (result["error"]) {
                await new confirmDialog().alert("Error",result["text"])
                return
            }
            return result
        } catch(error) {
            await new confirmDialog().alert("Server error",error.toString()+"\n"+endpoint)
        }
    }
    estimateTime(SDConfig,p) {
        if (!SDConfig.timeCalculation) return 80*p.num*p.steps
        //if (!SDConfig.timeCalculation) return 5000
        return SDConfig.timeCalculation*p.num*p.steps
    }
    getStatus() {
        if (this.gs) return this.gs.getStatus()
        if (this.d2) return this.d2.getStatus()
        return this.status
    }


    async estimateTimeQueue(SDConfig) {
        // This is not implemented now!
        return {};
        if (SDConfig.type!=="SDGRPC") return {};
        // get queue here
            let infres= [];
            return {'infoqueue':infres,'currentQueueSize':0,estimatedGenerationTime:0}
        return {};
    }

    async cancelRequest(SDConfig,taskid) {
        if (SDConfig.type==="SDGRPC") {  // using GRPC
            this.gs=this.createSDGrpc();
            try {
                await this.gs.cancelRequest(SDConfig,taskid);
            } catch (e) {}
        }
    }

    async runSD(SDConfig, p) {

        p.config=SDConfig
         if (SDConfig.type==="SDGRPC") {  // using GRPC
            let startTime = performance.now()

            this.gs=this.createSDGrpc();
            let imgs
            try {
                imgs= await this.gs.runSD(SDConfig, p)
            } catch (e) {}

            let endTime = performance.now()

            let duration=endTime-startTime
            SDConfig.timeCalculation=duration/p.num/p.steps
            return imgs            
        }        
        this.status="waiting"
        let seed
        if (!p.seed) { seed = -1 } else { seed = parseInt(p.seed) }

        let inpainting_fill_options = ['fill', 'original', 'latent noise', 'latent nothing',"g-diffusion"]
        let inpainting_fill = inpainting_fill_options.indexOf(SDConfig.inpaint_mask_content)
        let res=await this.switchModel(SDConfig,p)
        if (!res) {
            this.status="error"
            return
        }
        let j = {
            "enable_hr": p.enable_hr,
            "denoising_strength": 0,
            "firstphase_width": 0,
            "firstphase_height": 0,
            "prompt": p.prompt,
            "seed": seed,
            "subseed": -1,
            "subseed_strength": 0,
            "seed_resize_from_h": -1,
            "seed_resize_from_w": -1,
            "batch_size": 1,
            "n_iter": parseInt(p.num),
            "steps": parseInt(p.steps),
            "cfg_scale": parseFloat(p.cfg_value),
            "width":  parseInt(SDConfig.width),
            "height":  parseInt(SDConfig.height),
            "restore_faces":  p.restore_faces,
            "tiling":  p.tiling,
            "negative_prompt": p.negative_prompt,
            "eta": 0,
            "s_churn": 0,
            "s_tmax": 0,
            "s_tmin": 0,
            "s_noise": 1,
            "override_settings": {},
            "sampler_index": p.sampling_method
          }
          if (p.enable_hr) j.denoising_strength=0.7
          if (p.mode==="img2img" || p.mode==="inpainting"  || p.mode==="inpainting_original") {
            j.init_images=["data:image/png;base64,"+p.image64]
            j.denoising_strength=p.strength
            j.resize_mode=0
            j.inpaint_full_res= false
            if (p.maskImage64) {
                j.mask="data:image/png;base64,"+p.maskImage64
              //  j.mask_blur=parseInt(SDConfig.inpaint_mask_blur)
                console.log("fill", inpainting_fill)
            //    j.inpainting_fill= inpainting_fill
                j.denoising_strength=1.0
                j.inpainting_fill=2
                j.mask_blur=0
        }

          }





        let data = JSON.stringify(j)
        let startTime = performance.now()
        this.status="processing"
        let response = await this.getServerData(p,data, SDConfig)

        if (!response) {
            this.status="error"
            return
        }
        this.status="ready"
        let endTime = performance.now()
        let duration=endTime-startTime
        SDConfig.timeCalculation=duration/p.num/p.steps
        let images = []
        p.seedList = [] 
        let s = response["info"]
        let info = JSON.parse(s)

        let b64Data
        let allSeeds=info["all_seeds"]
            for(let i=0;i<p.num;i++) {
                b64Data = response["images"][i ] // image in list
                p.seedList[i] = allSeeds[i]+""
                let img={base64: b64Data}
                img.seed=p.seedList[i]
                images.push(img)
            }
        return images    
    }
    
    async getModels(SDConfig) {

        let endpoint = SDConfig.url
        endpoint = this.strip(endpoint, "/")
        endpoint += "/sdapi/v1/sd-models"
        let engineList=[]
        let result
        try {
            let res= await fetch(endpoint, {
                headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
                },
                method: 'get'
            })
            result=await res.json()
            if (result["error"]) {
                await new confirmDialog().alert("Error",result["text"])
                return
            }
        } catch(error) {
            await new confirmDialog().alert("Server error",error.toString()+"\n"+endpoint)
        }
//        console.log(result)
        for(let i=0;i<result.length;i++) {
            let m=result[i]
            engineList.push({id:m.model_name,hash:m.hash})
        }

        return engineList
    }
    async switchModel(SDConfig,p) {
        let list=await this.getModels(SDConfig)
        if (!list) return false
        let model=""
        model=SDConfig.model
        if (p.mode==="inpainting") {
            model=SDConfig.inpainting_model
            if (!model) model="sd-v1-5-inpainting"
        }
        if (!model) {
            await new confirmDialog().alert("No model selected in config")
            return false
        }
        let title=""
        for (let i=0;i<list.length;i++) {
            let m=list[i]
            if (m.id===model) title=model+".ckpt ["+m.hash+"]"
        }

        if (!title) {
            await new confirmDialog().alert("Model not found: "+title)
            return false
        }
        let request={
            "sd_model_checkpoint":title
        }
        let reqData = JSON.stringify(request)
        let endpoint = SDConfig.url
        endpoint = this.strip(endpoint, "/")
        endpoint += "/sdapi/v1/options"
        try {
            let res= await fetch(endpoint, {
                headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
                },
                method: 'post',
                body: reqData
            })
            let result=await res.json()
            return true
        } catch(error) {
            await new confirmDialog().alert("Server error",error.toString()+"\n"+endpoint)
            return false
        }
    }
}

